import {z as zod} from "zod";

export type DuluxSpecificBehaviourWorkspaceCapabilityConfiguration = {
    /**
     * Event column identifiers that customer `get-details` is allowed to return.
     * `null` or omitted exposes every column on the template.
     */
    exposedEventColumns?: Array<string> | null;
    /**
     * Event container column identifiers that customer `get-details` is allowed to return.
     * `null` or omitted exposes every column on the template.
     */
    exposedEventContainerColumns?: Array<string> | null;
};

export const duluxSpecificBehaviourWorkspaceCapabilityConfigurationValidator: zod.ZodType<DuluxSpecificBehaviourWorkspaceCapabilityConfiguration> = zod.strictObject({
    exposedEventColumns: zod.string().min(1).array().nullable().optional(),
    exposedEventContainerColumns: zod.string().min(1).array().nullable().optional(),
});
